import Picture from 'components/picture';

export const StyledPicture = Picture.withConfig({
  margin: 'auto',
  maxWidth: '260px',
});
